import React, { useState } from "react";
/* Components */
import Button from "../button/button";
import { useMutation, useQueryClient } from "react-query";
import { useForm } from "react-hook-form";
import { forgotPassword } from "../../services/auth.service";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useTranslation } from 'react-i18next';

const RecoveryPassForm = () => {
  const [loading, setLoading] = useState(false);
  const { show } = useSnackbarStore();
  const { setInitialEvent } = useMixPanel();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const queryClient = useQueryClient();
  const { t } = useTranslation()

  const mutation = useMutation(forgotPassword, {
    onSuccess: (data) => {
      queryClient.setQueryData(["user-recovery-password"], data?.data);
      setInitialEvent(data,'SHAIA_RECOVERY_PASSWORD');
      show(t("recuperar_clave_correo_enviado"));
      localStorage.clear();
      setLoading(false);
    },
    onError: (error) => {
      show(t("error_general"), "error");
      setLoading(false);
    },
  });

  const onSubmit = (form) => {
    setLoading(true);
    mutation.mutate(form.email);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2 className="alt-h1">{t('cambiar_contrasena')}</h2>
      <div className="input-text">
        <label className="input-label">{t('email')}:</label>
        <input
          className="input-box"
          type="email"
          {...register("email", {
            required: t('requiredEmail'),
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              message: t('notValidEmail'),
            },
          })}
        />
        {errors.email && <span className="error">{errors.email.message}</span>}
      </div>
      <div className="form-CTA">
        <Button
          label={loading ? `${t("cambiar_clave_boton_enviando")} ...` : t("cambiar_clave_boton_enviar")}
          variant="primary"
          typeB="submit"
        />
      </div>
    </form>
  );
};

export default RecoveryPassForm;
